///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ClientLogVM } from '../../../generated/shared-types.model';
import { Principal } from '../../../shared/auth/principal.service';
import { mapStackTrace } from 'sourcemapped-stacktrace';

@Injectable({
    providedIn: 'root'
})
export class GtthLogSenderService {
    constructor(
        private readonly http: HttpClient,
        private readonly principal: Principal
    ) {}

    logError(clientError: string) {
        if (!clientError) {
            return;
        }

        mapStackTrace(clientError, (res: string[]) => {
            this.httpRequest({
                stackTrace: res?.length ? res.join('\n') : clientError
            });
        });
    }

    private httpRequest(logVM: ClientLogVM): void {
        if (this.principal.isAuthenticated()) {
            this.http.post(`/api/ui-error-logs`, logVM).subscribe();
        }
    }
}
